"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pescosansonesco": {
    "3f8d251c": [{
      "hkey": "a393714b",
      "slug": "colle-della-guardia",
      "name": "Colle della Guardia",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-colle-della-giuardia": [{
      "hkey": "a393714b",
      "slug": "colle-della-guardia",
      "name": "Colle della Guardia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e98df756": [{
      "hkey": "65c3998e",
      "slug": "decontra",
      "name": "Decontra",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-decontra": [{
      "hkey": "65c3998e",
      "slug": "decontra",
      "name": "Decontra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "10957a72": [{
      "hkey": "96cbf1ec",
      "slug": "dogli",
      "name": "Dogli",
      "primary": true,
      "skipSearch": false
    }],
    "contrada-dogli": [{
      "hkey": "96cbf1ec",
      "slug": "dogli",
      "name": "Dogli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;